<template>
    <Head>
        <title>{{ job.title }}</title>
        <meta
            name="description"
            :content="
                job.description != null
                    ? job.description.substring(0, 120) + '...'
                    : ''
            "
        />
        <meta
            name="keywords"
            content="Truck Driving Jobs,Truck Driving Jobs Near Me"
        />
        <meta property="og:title" :content="job.title" />
        <meta property="og:site_name" content="opencdljobs.com" />
        <meta
            property="og:description"
            :content="
                job.description != null
                    ? job.description.substring(0, 120) + '...'
                    : ''
            "
        />
        <meta property="og:type" content="website" />
        <meta
            property="og:url"
            :content="`https://opencdljobs.com/jobs/${job.id}/${job.slug}`"
        />
        <meta
            property="og:image"
            content="https://opencdljobs.com/images/opencdljobs.png"
        />
    </Head>
    <div class="mt-4 sm:mt-8 font-arial">
        <div class="max-w-7xl mx-auto">
            <div class="grid grid-cols-12 gap-4">
                <div class="col-span-12 lg:col-span-8">
                    <!-- <p
            v-if="job.sap"
            class="sm:mx-3 md:mx-0 mb-2 sm:mb-4 py-2 px-4 sm:rounded-md shadow border-t border-b sm:border-l sm:border-r border-blue-600 bg-blue-100 text-blue-900 text-sm font-semibold"
          >
            SAP drivers encouraged to apply!
          </p> -->

                    <div class="p-4 sm:p-6 bg-white shadow sm:rounded-md">
                        <!-- <p class="text-xs text-gray-500 font-medium">
              revised on {{ revisedOn || createdAt }}
            </p> -->
                        <h3
                            class="mt-1 text-lg leading-6 font-medium text-gray-900"
                        >
                            {{ job.title }}
                        </h3>

                        <!-- Revisit this section -->
                        <!-- <p
              v-if="job.hiring_area_type === 'proximity'"
              class="mt-1 text-sm text-gray-500 font-medium"
            >
              Hiring within {{ job.hiring_area_within }} miles of
              {{ job.hiring_area_zip }}
            </p> -->
                        <!-- <p
              v-if="job.hiring_area_type === 'state'"
              class="mt-1 text-sm text-gray-500 font-medium"
            >
              Hiring within the state of {{ job.hiring_area_state }}
            </p> -->
                        <!-- <div class="flex items-center justify-between">
                            <p class="mt-1 text-sm text-gray-500 font-medium">
                                Hiring in {{ job.zipcode }}
                            </p>

                            <div
                                class="lg:flex items-center space-x-1 border rounded bg-gray-50"
                            >
                                <p
                                    class="uppercase text-xs lg:text-sm tracking-wider px-1"
                                >
                                    job-status
                                </p>

                                <span
                                    :class="jobStatusClass"
                                    class="uppercase font-bold text-sm rounded px-2"
                                    >{{ job.job_status }}</span
                                >
                            </div>
                        </div> -->
                        <div
                            v-if="video"
                            class="mt-4 relative rounded-md overflow-hidden"
                            style="padding-top: 56.25%"
                        >
                            <iframe
                                class="absolute inset-0 w-full h-full"
                                :src="`https://www.youtube.com/embed/${video}`"
                                title="YouTube video player"
                                frameborder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowfullscreen
                            ></iframe>
                        </div>

                        <div
                            v-if="screeenpalVideo"
                            class="mt-4 relative rounded-md overflow-hidden"
                            style="padding-top: 56.25%"
                        >
                            <iframe
                                class="absolute inset-0 w-full h-full"
                                :src="`${screeenpalVideo}`"
                                title="YouTube video player"
                                frameborder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowfullscreen
                            ></iframe>
                        </div>

                        <div class="mt-4 border-t"></div>

                        <div class="mt-4">
                            <p class="flex items-center space-x-2">
                                <span class="text-gray-500">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        class="h-4 w-4"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                    >
                                        <path
                                            fill-rule="evenodd"
                                            d="M4 4a2 2 0 012-2h8a2 2 0 012 2v12a1 1 0 110 2h-3a1 1 0 01-1-1v-2a1 1 0 00-1-1H9a1 1 0 00-1 1v2a1 1 0 01-1 1H4a1 1 0 110-2V4zm3 1h2v2H7V5zm2 4H7v2h2V9zm2-4h2v2h-2V5zm2 4h-2v2h2V9z"
                                            clip-rule="evenodd"
                                        />
                                    </svg>
                                </span>
                                <span
                                    class="text-sm text-gray-600 font-medium"
                                    >{{ job.company.name }}</span
                                >
                                <span v-if="isAgent" class="text-sm">
                                    {{ job.label ? ` - ${job.label}` : "" }}
                                </span>
                            </p>

                            <p class="">
                                <span class="text-2xl font-medium">{{
                                    weeklyPayRange
                                }}</span>
                                / week
                            </p>
                            <p
                                class="mt-2 flex items-center space-x-2"
                                v-if="job.cost_per_mile"
                            >
                                <span
                                    class="px-4 py-1 rounded-md bg-blue-600 text-white text-sm font-medium"
                                    >CPM {{ job.cost_per_mile }}</span
                                >
                            </p>
                        </div>

                        <div class="mt-4">
                            <div class="grid grid-cols-2 md:rid-cols-3 gap-4">
                                <p class="flex items-center space-x-2">
                                    <span class="text-blue-600">
                                        <TruckIcon class="w-5" />
                                    </span>
                                    <span
                                        class="text-sm font-medium text-gray-600"
                                        >{{
                                            job.truck == "0"
                                                ? "Take Truck Home"
                                                : "Leave Truck at DC"
                                        }}</span
                                    >
                                </p>
                                <p class="flex items-center space-x-2">
                                    <span class="text-blue-600">
                                        <CheckCircleIcon class="h-5 w-5" />
                                    </span>
                                    <span
                                        v-if="job.touch_freight"
                                        class="text-sm font-medium text-gray-600"
                                        >Driver Unloads Freight</span
                                    >
                                    <span
                                        v-else
                                        class="text-sm font-medium text-gray-600"
                                        >No Touch Freight</span
                                    >
                                </p>
                                <p class="flex items-center space-x-2">
                                    <span class="text-blue-600">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 512 512"
                                            class="w-5"
                                        >
                                            <path
                                                fill="currentColor"
                                                d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm92.49 313l-20 25a16 16 0 01-22.49 2.5l-67-49.72a40 40 0 01-15-31.23V112a16 16 0 0116-16h32a16 16 0 0116 16v144l58 42.5a16 16 0 012.49 22.5z"
                                            />
                                        </svg>
                                    </span>
                                    <span
                                        class="text-sm font-medium text-gray-600"
                                        >{{ job.reset_hours }} hours Reset</span
                                    >
                                </p>
                                <p class="flex items-center space-x-2">
                                    <span
                                        v-if="job.pets_allowed"
                                        class="text-blue-600"
                                    >
                                        <CheckCircleIcon class="h-5 w-5" />
                                    </span>
                                    <span v-else class="text-red-500">
                                        <XCircleIcon class="h-5 w-5" />
                                    </span>
                                    <span
                                        class="text-sm font-medium text-gray-600"
                                        >Pets Allowed</span
                                    >
                                </p>
                                <p class="flex items-center space-x-2">
                                    <span class="text-blue-600">
                                        <FlaskIcon class="h-5 w-5" />
                                    </span>
                                    <span
                                        v-if="job.drug_test === 'hair'"
                                        class="text-sm font-medium text-gray-600"
                                        >Drug Test: Hair</span
                                    >
                                    <span
                                        v-if="job.drug_test === 'urine'"
                                        class="text-sm font-medium text-gray-600"
                                        >Drug Test: Urine</span
                                    >
                                </p>
                                <p class="flex items-center space-x-2">
                                    <span
                                        v-if="job.riders_allowed"
                                        class="text-blue-600"
                                    >
                                        <CheckCircleIcon class="h-5 w-5" />
                                    </span>
                                    <span v-else class="text-red-500">
                                        <XCircleIcon class="h-5 w-5" />
                                    </span>
                                    <span
                                        class="text-sm font-medium text-gray-600"
                                        >Riders Allowed</span
                                    >
                                </p>
                            </div>
                        </div>

                        <div class="mt-8 space-y-2">
                            <div
                                class="tip-tap text-sm"
                                v-html="job.description"
                            ></div>
                        </div>
                    </div>
                </div>

                <div class="col-span-12 lg:col-span-4">
                    <!-- The sticky doesn't play well with expanding and collapsing items -->
                    <div>
                        <template v-if="isAgent">
                            <div class="space-y-4">
                                <InfoCard
                                    v-for="(info, index) in infos"
                                    :key="`info-${index}`"
                                    :info="info"
                                />
                            </div>
                            <div
                                class="px-4 py-4 bg-white shadow sm:rounded-md mt-4"
                            >
                                <h3 class="font-bold">Job Facts</h3>
                                <ul
                                    class="mt-4 text-sm max-w-lg"
                                    v-if="jobFacts.length"
                                >
                                    <li
                                        v-for="(jobFact, index) in jobFacts"
                                        :key="`key_point_${index}`"
                                        class="flex space-x-2"
                                    >
                                        <p class="font-medium">
                                            {{ index + 1 }}.
                                        </p>
                                        <p
                                            class="text-gray-700 first-letter:uppercase"
                                        >
                                            {{ jobFact }}
                                        </p>
                                    </li>
                                </ul>
                            </div>
                        </template>

                        <template v-else>
                            <div class="space-y-4">
                                <div
                                    class="px-4 py-4 bg-white shadow sm:rounded-md"
                                >
                                    <div
                                        class="flex flex-col items-center space-y-2"
                                    >
                                        <a
                                            ref="main-call-button"
                                            v-if="job.company.phone_number"
                                            target="_blank"
                                            :href="`tel:${job.company.phone_number}`"
                                            class="flex justify-center items-center w-full sm:w-64 lg:w-full space-x-2 bg-blue-500 text-white text-sm font-medium px-4 py-3 sm:py-2 rounded-md shadow hover:bg-blue-600 transition"
                                            id="main-apply-button"
                                        >
                                            <span>Call Now</span>
                                            <span
                                                ><PhoneIcon class="h-5 w-5"
                                            /></span>
                                        </a>

                                        <Link
                                            v-if="job.zoho_application_link"
                                            class="flex justify-center items-center w-full sm:w-64 lg:w-full space-x-2 bg-blue-600 text-white text-sm font-medium px-4 py-3 sm:py-2 rounded-md shadow hover:bg-blue-700 transition"
                                            :href="
                                                route('job.apply', {
                                                    jobTitle: this.job.title,
                                                    applicationLink:
                                                        this.job
                                                            .zoho_application_link,
                                                })
                                            "
                                        >
                                            <span>Apply Now</span>
                                            <span>
                                                <ExternalLinkIcon
                                                    class="h-5 w-5"
                                                />
                                            </span>
                                        </Link>

                                        <button
                                            v-else
                                            type="submit"
                                            @click="updateJobTracker"
                                            class="w-full"
                                        >
                                            <div>
                                                <a
                                                    ref="main-apply-button"
                                                    target="_blank"
                                                    :href="
                                                        job.job_application_url
                                                    "
                                                    class="flex justify-center items-center w-full sm:w-64 lg:w-full space-x-2 bg-blue-600 text-white text-sm font-medium px-4 py-3 sm:py-2 rounded-md shadow hover:bg-blue-700 transition"
                                                >
                                                    <span>Apply Now</span>
                                                    <span>
                                                        <ExternalLinkIcon
                                                            class="h-5 w-5"
                                                        />
                                                    </span>
                                                </a>
                                            </div>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div
                                class="mt-4 px-4 py-4 bg-white shadow sm:rounded-md"
                            >
                                <h3 class="text-sm font-medium">Share Job</h3>
                                <div class="mt-2 space-x-2">
                                    <a
                                        class="inline-flex p-2 rounded-md hover:shadow"
                                        :href="`https://www.facebook.com/sharer/sharer.php?u=${shareableUrl}`"
                                        target="_blank"
                                        rel="noopener"
                                        aria-label="facebook share"
                                        title="facebook share"
                                    >
                                        <FacebookIcon
                                            class="inline-block h-6 w-6"
                                        />
                                    </a>
                                    <button
                                        @click="copyShareableUrl"
                                        type="button"
                                        class="inline-flex p-2 rounded-md hover:shadow"
                                        aria-label="share"
                                    >
                                        <ShareIcon
                                            class="inline-block h-6 w-6"
                                        />
                                    </button>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <template v-if="!isAgent">
        <a
            ref="mobile-apply-button"
            class="sm:invisible fixed bottom-8 right-8 px-6 py-3 flex items-center justify-center space-x-2 bg-blue-600 text-sm font-medium text-white hover:bg-blue-700 rounded-full shadow transition"
            :href="job.job_application_url"
            target="_blank"
        >
            <span>Apply Now</span>
            <ExternalLinkIcon class="h-5 w-5" />
        </a>
        <a
            ref="mobile-call-button"
            class="sm:hidden sm:invisible fixed right-8 mb-2 px-6 py-3 flex items-center justify-center space-x-2 bg-blue-500 text-sm font-medium text-white hover:bg-blue-600 rounded-full shadow transition"
            :class="job.job_application_url ? 'bottom-20' : 'bottom-8'"
            :href="`tel:${job.company.phone_number}`"
            v-show="job.company.phone_number"
        >
            <span>Call Now</span>
            <PhoneIcon class="h-5 w-5" />
        </a>
    </template>

    <transition
        enter-from-class="transform translate-y-full opacity-0"
        leave-to-class="transform translate-y-full opacity-0"
        leave-from-class="transform translate-y-0 opacity-100"
        enter-to-class="transform translate-y-0 opacity-100"
        enter-active-class="transition duration-150"
        leave-active-class="transition duration-100"
    >
        <div
            v-if="copied"
            class="fixed bottom-4 inset-x-6 max-w-sm mx-auto bg-white bg-opacity-90 rounded px-4 py-3 text-center font-medium text-sm border border-gray-300"
        >
            Link copied to clipboard!
        </div>
    </transition>
</template>

<script>
import inViewport from "in-viewport";
import { DateTime } from "luxon";
import { ShareIcon } from "@heroicons/vue/outline";
import {
    CheckCircleIcon,
    ExternalLinkIcon,
    PhoneIcon,
    XCircleIcon,
} from "@heroicons/vue/solid";
import { Head, Link, useForm } from "@inertiajs/inertia-vue3";
import {
    FacebookIcon,
    FlaskIcon,
    TwitterIcon,
    TruckIcon,
} from "@/components/Icons";
import InfoCard from "@/components/Jobs/InfoCard";

export default {
    props: {
        endorsements: Object,
        experience_times: Object,
        job: Object,
        auth: Object,
        additional_data: {
            type: Object,
            required: false,
        },
    },

    data: () => ({
        copied: false,
        route: window.route,
        form: useForm({
            apply: true,
        }),
    }),

    created() {
        const structuredData = {
            "@context": "https://schema.org/",
            "@type": "JobPosting",
            datePosted: DateTime.fromISO(
                this.job.revised_on || this.job.created_at
            ).toISODate(),
            validThrough: DateTime.fromISO(
                this.job.end_date || this.extendedDate
            ).toISODate(),
            description: this.job.description,
            hiringOrganization: {
                "@type": "Organization",
                name: "Open CDL Jobs",
                sameAs: "https://opencdljobs.com",
            },
            url:
                "https://opencdljobs.com/jobs/" +
                this.job.id +
                "/" +
                this.job.slug,
            jobLocation: [...this.jobLocations],
            title: this.job.title,
            industry: "Trucking",
            baseSalary: {
                "@type": "MonetaryAmount",
                currency: "USD",
                value: {
                    "@type": "QuantitativeValue",
                    minValue: this.job.min_value || 1400,
                    maxValue: this.job.max_value || 1600,
                    value:
                        this.job.average_weekly_pay ||
                        this.job.job_info?.average_weekly_pay_range,
                    unitText: "WEEK",
                },
            },
            responsibilities: this.job.responsibilities || "-",
            qualifications: this.job.qualifications || "-",
            experienceRequirements: {
                "@type": "OccupationalExperienceRequirements",
                monthsOfExperience: this.job.min_experience_required || "12",
                description: this.job.experience_requirements || "-",
            },
            identifier: {
                "@type": "PropertyValue",
                name: this.job.company.name,
                value: this.job.company.id,
            },
            employmentType: this.employmentType,
        };

        const script = document.createElement("script");
        script.setAttribute("type", "application/ld+json");
        script.textContent = JSON.stringify(structuredData);
        document.head.appendChild(script);
    },

    mounted() {
        const mainApplyButton = this.$refs["main-apply-button"];
        const mainCallButton = this.$refs["main-call-button"];
        const mobileApplyButton = this.$refs["mobile-apply-button"];
        const mobileCallButton = this.$refs["mobile-call-button"];

        document.addEventListener(
            "scroll",
            function () {
                if (inViewport(mainApplyButton)) {
                    mobileApplyButton.style.transform = "translateY(100%)";
                    mobileApplyButton.style.opacity = 0;
                } else if (inViewport(mainCallButton)) {
                    mobileCallButton.style.transform = "translateY(100%)";
                    mobileCallButton.style.opacity = 0;
                } else {
                    if (mobileApplyButton) {
                        mobileApplyButton.style.transform = "translateY(0)";
                        mobileApplyButton.style.opacity = 1;
                    }
                    if (mobileCallButton) {
                        mobileCallButton.style.transform = "translateY(0)";
                        mobileCallButton.style.opacity = 1;
                    }
                }
            },
            {
                passive: true,
            }
        );
    },

    computed: {
        jobStatusClass() {
            return {
                "bg-green-500 text-white": this.job.job_status === "open",
                "bg-red-500 text-white": this.job.job_status === "closed",
                "bg-purple-500 text-white": this.job.job_status === "ask",
                "bg-yellow-500 text-black": this.job.job_status === "hidden",
            };
        },

        jobLocations() {
            let locations = [];
            for (let index = 0; index < this.job.locations.length; index++) {
                // const element = this.job.locations[index];
                locations.push({
                    "@type": this.job.locations[index].location_type,
                    address: {
                        "@type": this.job.locations[index].address_type,
                        streetAddress:
                            this.job.locations[index].street_address || "-",
                        addressLocality:
                            this.job.locations[index].address_locality,
                        addressRegion:
                            this.job.locations[index].address_region || "-",
                        postalCode:
                            this.job.locations[index].postal_code || "-",
                        addressCountry:
                            this.job.locations[index].address_country,
                    },
                });
            }

            return locations;
        },

        createdAt() {
            return DateTime.fromISO(this.job.created_at).toLocaleString(
                DateTime.DATE_MED
            );
        },

        extendedDate() {
            return DateTime.now().plus({ months: 1 });
        },

        revisedOn() {
            if (!this.job.revised_on) return null;

            return DateTime.fromISO(this.job.revised_on).toLocaleString(
                DateTime.DATE_MED
            );
        },

        endorsementsString() {
            return Object.entries(this.job.endorsements)
                .filter((entry) => entry[1])
                .map((entry) => this.endorsements[entry[0]])
                .join(", ");
        },

        weeklyPayRange() {
            if (this.job.job_info?.average_weekly_pay_range) {
                return this.job.job_info?.average_weekly_pay_range;
            }
            return "-";
        },

        weeklyPay() {
            return Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
            }).format(this.job.average_weekly_pay);
        },

        shareableUrl() {
            return window.location.href;
        },

        video() {
            const url = this.job.video_url;

            if (!url) {
                return null;
            }

            if (url.includes("?v=")) {
                return url.split("?v=").at(-1);
            } else if (url.includes("youtu.be/")) {
                return url.split("youtu.be/").at(-1);
            }

            return null;
        },

        screeenpalVideo() {
            const url = this.job.video_url;

            if (!url) {
                return null;
            }

            if (url.includes("screenpal.com/watch")) {
                return url;
            }
            return null;
        },

        isAgent() {
            return (
                this.auth &&
                (this.auth.role.includes("agent") ||
                    this.auth.role.includes(
                        "Restricted Agent to companies US Xpress, Heartland and DB Schenker"
                    ))
            );
        },


        employmentType() {
            return this.job.job_type.slug === "C" ? "PART_TIME" : "FULL_TIME";
        },

        companyInfo() {
            return this.job.company.company_info;
        },

        hiringRequirementsAndDocumentation() {
            return this.companyInfo
                ? this.companyInfo.hiring_requirements_and_documentation
                : "";
        },

        sapProgram() {
            return this.companyInfo ? this.companyInfo.sap_program : "";
        },

        equipmentInformation() {
            return this.companyInfo
                ? this.companyInfo.equipment_information
                : "";
        },

        jobFacts() {
            return Array.from(Array(10).keys())
                .map((key) => this.job.job_info[`job_fact_${key + 1}`])
                .filter(Boolean);
        },

        infos() {
            return [
                {
                    title: "Hiring Requirements and Documentation",
                    body: this.hiringRequirementsAndDocumentation,
                },
                {
                    title: "App Process",
                    body: this.job.company.app_process,
                },
                {
                    title: "Orientation",
                    body: this.job.company.orientation,
                },
                {
                    title: "Company Info",
                    body: this.additional_data.company_notes,
                },
                {
                    title: "SAP Program",
                    body: this.sapProgram,
                },
                {
                    title: "Equipment Information",
                    body: this.equipmentInformation,
                },
                {
                    title: "Job Notes",
                    body: this.additional_data.job_notes,
                },
            ].filter((item) => item.body);
        },
    },

    methods: {
        copyShareableUrl() {
            navigator.clipboard
                .writeText(this.shareableUrl)
                .then(() => {
                    this.copied = true;
                    setTimeout(() => (this.copied = false), 3000);
                })
                .catch((err) => {});
        },

        updateJobTracker() {
            this.form.post(this.route("update.job.tracker", { job: this.job }));
        },
    },

    components: {
        Link,
        CheckCircleIcon,
        ExternalLinkIcon,
        FacebookIcon,
        FlaskIcon,
        Head,
        PhoneIcon,
        ShareIcon,
        TruckIcon,
        TwitterIcon,
        XCircleIcon,
        InfoCard,
    },
};
</script>

<style scoped>
.tip-tap {
    :deep(& h1) {
        font-size: 24px;
        font-weight: bold;
        padding-top: 1.25rem;
        padding-bottom: 1.25rem;
    }

    :deep(& h2) {
        font-size: 18px;
        font-weight: bold;
        padding-top: 1.25rem;
        padding-bottom: 1.25rem;
    }

    :deep(& h3) {
        font-size: 16px;
        font-weight: bold;
        padding-top: 1.25rem;
        padding-bottom: 1.25rem;
    }

    :deep(& h4) {
        font-size: 14px;
        font-weight: bold;
        padding-top: 1.25rem;
        padding-bottom: 1.25rem;
    }
}
</style>
